import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const QuickActionComposeSvg = () => (
  <svg width='45' height='38' viewBox='0 0 45 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      opacity='0.5'
      d='M9.9375 37.8691H22.9921C35.1122 37.8691 44.9375 28.0438 44.9375 15.9237V15.9237C44.9375 8.71386 39.0928 2.86914 31.8829 2.86914H31.0396C19.3853 2.86914 9.9375 12.3169 9.9375 23.9713V37.8691Z'
      fill='url(#paint0_linear_2937_18545)'
    />
    <path
      d='M4 14.8691H20C21.1 14.8691 22 15.7691 22 16.8691V28.8691C22 29.9691 21.1 30.8691 20 30.8691H4C2.9 30.8691 2 29.9691 2 28.8691V16.8691C2 15.7691 2.9 14.8691 4 14.8691Z'
      stroke='#3F3D56'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M22 16.8691L12 23.8691L2 16.8691'
      stroke='#3F3D56'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M27.0137 6.16888V15.0971'
      stroke='#3F3D56'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M22.5498 10.633H31.478'
      stroke='#3F3D56'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_2937_18545'
        x1='46.2703'
        y1='35.2274'
        x2='57.8353'
        y2='-32.7069'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#283E28' />
        <stop offset='0.895833' stopColor='#ADC8B6' />
      </linearGradient>
    </defs>
  </svg>
);

export const QuickActionComposeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={QuickActionComposeSvg} {...props} />
);
